import { TNameTitle } from '@interfaces/common/common';
import { IItemsResponse } from '@interfaces/common/response';
import {
	IConnectionLog,
	IConnectionLogsFilterMiddleware,
	IConnectionLogsFilterUser,
} from '@interfaces/middlewareSMO/connectionLogs';
import { IConnectionLogsDTO } from '@interfaces/middlewareSMO/dto/connectionLogsDTO';
import { IMiddlewareSMODTO, IMiddlewareUpdateLogPMDTO } from '@interfaces/middlewareSMO/dto/middlewareSMO';
import { IMiddlewareSMO } from '@interfaces/middlewareSMO/middlewareSMO';

import { client } from './client';
import { URL } from './urls';

const {
	middlewareSMO,
	middlewareSMOGet,
	middlewareSMOStatuses,
	middlewareSMOConnectionLogs,
	middlewareSMOConnectionLogsStatic,
} = URL;

export const getMiddlewareSMO = (dto: IMiddlewareSMODTO): Promise<IItemsResponse<IMiddlewareSMO>> => {
	return client.get(`/${middlewareSMOGet}`, { params: dto });
};

export const getMiddlewareStatuses = (): Promise<TNameTitle[]> => {
	return client.get(`/${middlewareSMOStatuses}`);
};

export const removeMiddlewareSMO = (id: string): Promise<void> => client.post(`/${middlewareSMO}/${id}/remove`, {});
export const enableMiddlewareSMO = (id: string): Promise<void> => client.post(`/${middlewareSMO}/${id}/enable`, {});
export const disableMiddlewareSMO = (id: string): Promise<void> => client.post(`/${middlewareSMO}/${id}/disable`, {});

export const updateMiddlewareLogPM = ({ id, ...dto }: IMiddlewareUpdateLogPMDTO): Promise<void> => {
	return client.post(`/${middlewareSMO}/${id}/log-pm-update`, dto);
};

export const enableMiddlewareLogPM = (id: string): Promise<void> => {
	return client.post(`/${middlewareSMO}/${id}/log-pm-enable`, {});
};

export const disableMiddlewareLogPM = (id: string): Promise<void> => {
	return client.post(`/${middlewareSMO}/${id}/log-pm-disable`, {});
};

export const getConnectionLogs = (dto: IConnectionLogsDTO): Promise<IItemsResponse<IConnectionLog>> => {
	return client.get(`/${middlewareSMOConnectionLogs}`, { params: dto });
};

export const getConnectionLogsAvailableUsers = (): Promise<IConnectionLogsFilterUser[]> => {
	return client.get(`/${middlewareSMOConnectionLogsStatic}/available-users`);
};

export const getConnectionLogsConnectionStatuses = (): Promise<TNameTitle[]> => {
	return client.get(`/${middlewareSMOConnectionLogsStatic}/connection-statuses`);
};

export const getConnectionLogsEventTypes = (): Promise<TNameTitle[]> => {
	return client.get(`/${middlewareSMOConnectionLogsStatic}/event-types`);
};

export const getConnectionLogsMiddlewares = (): Promise<IConnectionLogsFilterMiddleware[]> => {
	return client.get(`/${middlewareSMOConnectionLogsStatic}/middlewares`);
};

export const getConnectionLogsSources = (): Promise<TNameTitle[]> => {
	return client.get(`/${middlewareSMOConnectionLogsStatic}/sources`);
};
